/* eslint-disable import/no-cycle */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Logo from './logo';
import Menu from './menu';
import Admin from './admin';
import AccountInfo from './AccountInfo';
import MobileHeader from './mobileHeader';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Header = ({ locale, userName, userRights = null }) => {
  const {
    headerLinks: { labelWelcome }
  } = useLocalizedStringsContext();
  const [showAccountInfo, setShowAccountInfo] = useState(false);

  return (
    <>
      <header id="header">
        <div className="header-main">
          <div className="nav-main">
            <div className="nav-inner">
              <ul>{userRights && <Admin userRights={userRights} />}</ul>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flex: '1 1 0%'
                }}
              >
                <ul>
                  {userName && (
                    <Menu
                      locale={locale}
                      userName={userName}
                      userRights={userRights}
                    />
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bottom-main">
          <div className="header-bottom-container">
            <div className="header-bottom-inner">
              <Logo locale={locale} userRights={userRights} />
              {userName && (
                <div className="header-bottom-username-main">
                  <span className="header-bottom-welcome-label">
                    {labelWelcome}
                  </span>
                  <button
                    style={{
                      background: 'transparent',
                      border: 0,
                      textDecoration: 'underline',
                      padding: 0,
                      fontSize: 16
                    }}
                    type="button"
                    className="header-bottom-username"
                    onClick={() => setShowAccountInfo(true)}
                  >
                    {userName}
                  </button>
                </div>
              )}  
            </div>
          </div>
        </div>
      </header>
      {userName && <MobileHeader locale={locale} userRights={userRights} />}

      <section id="banner" />
      {showAccountInfo && (
        <AccountInfo
          onClose={() => {
            setShowAccountInfo(false);
          }}
        />
      )}
    </>
  );
};

Header.propTypes = {
  locale: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isQuoteApprovalDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool
  })
};

export default Header;
